import axios from "axios";
import jwt_decode from "jwt-decode";

import Constantes from "../../utils/Constantes";

const API_URL = Constantes.api_url;
const LOGIN = `${API_URL}/auth/signin`;
const LOGIN_SSO = `${API_URL}/auth/loginSSO`;
const URL_LOGOUT = `${API_URL}/auth/logout`;
const IS_USER = `${API_URL}/usuariosihrus/isUser`;

const GET_ESTADO_ACCESO_CREDENCIALES = `${API_URL}/auth/getEstadoAccesoCredenciales`;


/**
 * Login de la aplicación a través de un formulario.
 *
 * @param {String} values
 * @returns
 */
export async function login(values) {
  const uninterceptedAxiosInstance = axios.create();
  return uninterceptedAxiosInstance
    .post(LOGIN, values)
    .then((response) => {
      if (response?.data) {
        localStorage.setItem("user", JSON.stringify(response?.data));
        localStorage.setItem("showModalHome",true)
      }
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function loginSSO (sso) {
  const decoded = jwt_decode(sso);
  const uninterceptedAxiosInstance = axios.create();
  return await uninterceptedAxiosInstance({
    method: 'GET',
    url: `${LOGIN_SSO}/${await decoded?.sub}`,
    headers:{'Authorization': sso}
  })
    .then(response => {
      if (response?.data) 
        localStorage.setItem('user', JSON.stringify(response?.data))
        localStorage.setItem("showModalHome",true)
    })
}

export async function isUser(usuariosirhus) {
  return await axios({
    method: "POST",
    url: `${IS_USER}/`,
    data:usuariosirhus
  })
  .then((response) => {
    return response.data
  })
}
/**
 * Eliminar la sesión actual del usuario
 */
export async function logout() {
   try {
    await axios.post(URL_LOGOUT, {}, { withCredentials: true });
  } catch (logoutError) {
    // console.error("Error al hacer logout", logoutError);
  }
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("dataAdquisicion");
  localStorage.removeItem("dataInfoex");
  localStorage.removeItem("dataIrpfHabiliciones");
  localStorage.removeItem("urlAlcantara");
  localStorage.removeItem("tipoActo");
  localStorage.setItem("breadcrumbsHistory", "");
}

export async function getEstadoAccesoCredenciales() {
  

  try {
    const response = await axios.get(GET_ESTADO_ACCESO_CREDENCIALES);
    
    return response.data;
  } catch (error) {
    // console.error("Error al obtener el estado:", error);
    return "Error: Fallo al obtener el estado de acceso a las credenciales";
  }
}